import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Props-Schnittstelle
interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Wenn noch geladen wird, zeige Ladeanzeige
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Wenn nicht authentifiziert, weiterleiten
  if (!isAuthenticated) {
    // Den vollständigen Deeplink behalten, damit der Login nicht auf der
    // Projektübersicht endet, sondern genau zur angeforderten Seite zurückkehrt.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Ansonsten die geschützten Inhalte anzeigen
  return <>{children}</>;
};

export default AuthGuard;
